import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Condition } from '@upstart/harmony/lib/constants';
import ConditionCheckbox from './ConditionCheckbox';
import CarMappingTree from './CarMappingTree';
import YearRange from './YearRange';

/**
 * Include 2 previous years and the next year.
 */
const DEFAULT_RANGE = [
  new Date().getFullYear() - 2,
  new Date().getFullYear() + 1,
];

function AccessoryMapping({ accessory, dealer, setAccessory }) {
  const [mapping, setMapping] = useState(accessory.mapping || {});
  const [yearRange, setYearRange] = useState(
    accessory.yearRange || DEFAULT_RANGE,
  );

  const conditions = accessory.conditions || [];

  useEffect(() => {
    let newConditions = [...conditions];

    // If there were any makes or models selected - automatically add "New" condition
    if (!isEmpty(mapping)) {
      newConditions = newConditions.includes(Condition.NEW)
        ? newConditions
        : newConditions.concat(Condition.NEW);
    }

    setAccessory({
      ...accessory,
      mapping,
      yearRange,
      conditions: newConditions,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapping, yearRange]);

  return (
    <div className="accessory-mapping">
      <h4>{accessory.name} is available for the following conditions:</h4>
      <div className="row">
        <div className="col-md-3">
          <ConditionCheckbox
            selected={conditions}
            onChange={newConditions => {
              // Reset make model tree if "New" condition is unchecked
              if (!(newConditions || []).includes(Condition.NEW)) {
                setMapping({});
                setYearRange([...yearRange]);
              }
              setAccessory({ ...accessory, conditions: newConditions });
            }}
            dealer={dealer}
          />
        </div>
        <div className="col-md-3">
          <CarMappingTree
            dealer={dealer}
            mapping={mapping}
            yearRange={yearRange}
            setMapping={setMapping}
          />
        </div>
        <div className="col-md-3">
          <YearRange
            min={DEFAULT_RANGE[0]}
            max={DEFAULT_RANGE[1]}
            values={yearRange}
            onChange={setYearRange}
          />
        </div>
      </div>
    </div>
  );
}

AccessoryMapping.propTypes = {
  accessory: PropTypes.object,
  dealer: PropTypes.object,
  setAccessory: PropTypes.func,
};

export default AccessoryMapping;
